import { render, staticRenderFns } from "./FooterTableComponentGlobal.vue?vue&type=template&id=4d2fbbc9&"
import script from "./FooterTableComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./FooterTableComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./FooterTableComponentGlobal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VExpandTransition,VIcon,VList,VListItem,VListItemGroup,VListItemTitle,VMenu,VSelect})
